import(/* webpackMode: "eager", webpackExports: ["DocsLayoutShell"] */ "/app/src/app/docs/docs-layout-shell.tsx");
